import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import Spinner from "../../../Spinner";
import DataTable from '../../../DataTable';

@inject("reportingTemplateHeaderStore")
@observer
class ReportingHeaderList extends Component {
  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    children: PropTypes.node,
  }

  componentWillMount() {
    const { reportingTemplateHeaderStore } = this.props;
    if (!reportingTemplateHeaderStore.isLoading && !reportingTemplateHeaderStore.items.length) reportingTemplateHeaderStore.fetchItems();
  }

  handleDelete = (id) => {
    this.props.reportingTemplateHeaderStore.removeItems(id);
  }

  slug = 'export/report/header';
  columns = [
    { key: 'id', label: 'ID' },
    { key: 'title1', label: 'Title 1' },
    { key: 'title2', label: 'Title 2' },
    { key: 'logo', label: 'Logo' }
  ];

  render() {
    const { reportingTemplateHeaderStore, children } = this.props;
    if (reportingTemplateHeaderStore.isLoading) return <Spinner />;
    return (
      <div>
        <DataTable
          data={reportingTemplateHeaderStore.items.map((item) => {
            return {
              ...item,
              title1: <div>{item.title1} {!!item.default && <div className='chip' title='Default'>Def</div>}</div>,
              logo: <img src={item.logo} alt='logo' style={{ width: '100px', height: '100px' }} />
            }
          })}
          slug={this.slug}
          columns={this.columns}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
          allowDelete
          disableMultipleDelete
          resource='data-delivery'
        />
        {children}
      </div>
    );
  }
}

export default ReportingHeaderList;



// WEBPACK FOOTER //
// ./src/components/DataDelivery/ReportingTemplate/ReportingHeader/ReportingHeaderList.js